import { IDeleteColetaPrecoFornecedorUseCase } from "../../../presentation/useCases/delete/delete_coleta_preco_fornecedor_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteColetaPrecoFornecedorUseCase
 */

export class DeleteColetaPrecoFornecedorUseCase implements IDeleteColetaPrecoFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteColetaPrecoFornecedor(
    idColetaPrecoFornecedor: number,
  ): Promise<void> {
    await this.repository.deleteColetaPrecoFornecedor(
      idColetaPrecoFornecedor,
    );
  }
}
